import Customer from "models/Customer";
import Survey from "models/Survey";
import Report from "models/Report";

export const INIT = "report/INIT";
export const SET = "report/SET";
export const SET_LOCALE = "report/SET_LOCALE";
export const CHANGE_SEARCH_FORM = "report/CHANGE_SEARCH_FORM";
export const SET_REPORT_STATUS = "report/SET_REPORT_STATUS";
export const SET_REPORT_BY_ATTR_STATUS = "report/SET_REPORT_BY_ATTR_STATUS";
export const SET_SURVEY_ATTR_SHOW_STATUS = "report/SET_SURVEY_ATTR_SHOW_STATUS";
export const SET_EDIT_STATUS = "report/SET_EDIT_STATUS";
export const OPEN_INDUSTRY_MODAL = "report/OPEN_INDUSTRY_MODAL";
export const CLOSE_INDUSTRY_MODAL = "report/CLOSE_INDUSTRY_MODAL";
export const OPEN_INDUSTRY_BY_ATTR_MODAL = "report/OPEN_INDUSTRY_BY_ATTR_MODAL";
export const CLOSE_INDUSTRY_BY_ATTR_MODAL = "report/CLOSE_INDUSTRY_BY_ATTR_MODAL";
export const CHANGE_INDUSTRY_MODAL = "report/CHANGE_INDUSTRY_MODAL";
export const DECIDE_INDUSTRY = "report/DECIDE_INDUSTRY";
export const DECIDE_INDUSTRY_BY_ATTR = "report/DECIDE_INDUSTRY_BY_ATTR";
export const SET_ERRORS = "report/SET_ERRORS";
export const SET_LOADING = "surveyDetail/SET_LOADING";

export const initReport = () => ({
  type: INIT
});
export const setReport = res => ({
  type: SET,
  customer: new Customer(res.customer),
  survey: new Survey(res.survey),
  reportStatus: new Report(res.reportStatus),
  latestUpdateHistory: res.latestUpdateHistory,
  surveyAttrs: res.surveyAttrs,
  errors: res.errors,
  editStatus: false,
  loading: false,
  isPrevious: res.isPrevious,
  industries: res.industries,
});
export const changeSearchForm = (key, value) => ({
  type: CHANGE_SEARCH_FORM,
  key,
  value
});
export const setLocale = localeId => ({
  type: SET_LOCALE,
  localeId
});
export const setReportStatus = (res, method) => ({
  type: SET_REPORT_STATUS,
  res,
  method
});
export const setReportByAttrStatus = (res, method) => ({
  type: SET_REPORT_BY_ATTR_STATUS,
  res,
  method
});
export const setEditStatus = editStatus => ({
  type: SET_EDIT_STATUS,
  editStatus
});
export const openIndustryModal = (name, parentId, industryId) => ({
  type: OPEN_INDUSTRY_MODAL,
  name,
  parentId,
  industryId
});
export const closeIndustryModal = () => ({
  type: CLOSE_INDUSTRY_MODAL,
});
export const openIndustryByAttrModal = (name, parentId, industryId, obj) => ({
  type: OPEN_INDUSTRY_BY_ATTR_MODAL,
  name,
  parentId,
  industryId,
  obj
});
export const closeIndustryByAttrModal = () => ({
  type: CLOSE_INDUSTRY_BY_ATTR_MODAL,
});
export const changeIndustryModal = (name, value) => ({
  type: CHANGE_INDUSTRY_MODAL,
  name,
  value
});
export const decideIndustry = (parentId, industryId) => ({
  type: DECIDE_INDUSTRY,
  parentId,
  industryId
});
export const decideIndustryByAttr = (parentId, industryId) => ({
  type: DECIDE_INDUSTRY_BY_ATTR,
  parentId,
  industryId
});
export const setErrors = errors => ({
  type: SET_ERRORS,
  errors
});
export const setLoading = loading => ({
  type: SET_LOADING,
  loading
});
export const setSurveyAttrShowStatus = (attrIndex, itemIndex, val) => ({
  type: SET_SURVEY_ATTR_SHOW_STATUS,
  attrIndex,
  itemIndex,
  val
});

const initialState = {
  customer: new Customer(),
  survey: new Survey(),
  reportStatus: new Report(),
  latestUpdateHistory: {},
  surveyAttrs: [],
  editStatus: false,
  isPrevious: false,
  isOpenIndustryModal: false,
  isOpenIndustryByAttrModal: false,
  selectedAttrIndex: "0",
  selectedAttrItemIndex: "0",
  selectIndustry: "",
  modalIndustryId: "0",
  modalIndustryParentId: "0",
  loading: false,
  errors: []
};

const report = (state = initialState, action) => {
  switch (action.type) {
    case INIT: {
      return {
        ...initialState
      };
    }
    case SET: {
      const {
        customer,
        survey,
        reportStatus,
        latestUpdateHistory,
        surveyAttrs,
        editStatus,
        isPrevious,
        industries,
        loading,
        errors
      } = action;

      return {
        ...state,
        customer,
        survey,
        reportStatus,
        latestUpdateHistory,
        surveyAttrs,
        editStatus,
        isPrevious,
        industries,
        errors,
        loading
      };
    }
    case SET_LOCALE: {
      const { localeId } = action;
      const selectedSurveyLocale = state.surveyLocales.find(
        sl => sl.localeId === localeId
      );
      return { ...state, selectedSurveyLocale };
    }
    case SET_REPORT_STATUS: {
      const reportStatus = state.reportStatus.merge(action.res);

      return {
        ...state,
        reportStatus,
        editStatus:
            action.method === "update" || action.method === "cancel"
              ? false
              : state.editStatus,
      };
    }
    case SET_REPORT_BY_ATTR_STATUS: {
      const { attrIndex, itemIndex, arr, val } = action.res;
      const newItems = [...state.surveyAttrs[attrIndex].items];
      const shouldInitializeSubIndustry = (majorIndex, subIndex) => {
        return arr === majorIndex && (newItems[itemIndex][subIndex] === undefined || newItems[itemIndex][subIndex] === null);
      };
      if (shouldInitializeSubIndustry(18, 11)) {
        newItems[itemIndex][11] = "NULL";
      }
      if (shouldInitializeSubIndustry(19, 12)) {
        newItems[itemIndex][12] = "NULL";
      }
      if (shouldInitializeSubIndustry(20, 13)) {
        newItems[itemIndex][13] = "NULL";
      }
      newItems[itemIndex][arr] = val;

      if ([18, 19, 20].includes(arr)) {
        const subIndex = arr - 7;
        const currentSub = newItems[itemIndex][subIndex];
        if (!val || (currentSub && !val) || (val && !currentSub)) {
          newItems[itemIndex][subIndex] = "NULL";
        }
      }
      return {
        ...state,
        surveyAttrs: [
          ...state.surveyAttrs.slice(0, attrIndex),
          {
            ...state.surveyAttrs[attrIndex],
            items: newItems
          },
          ...state.surveyAttrs.slice(attrIndex + 1)
        ],
        reportByAttrStatus: newItems[itemIndex][arr]
      };
    }
    case SET_EDIT_STATUS: {
      const { editStatus } = action;
      return { ...state, editStatus };
    }
    case OPEN_INDUSTRY_MODAL: {
      const { name, parentId, industryId } = action;
      return {
        ...state,
        selectIndustry: name,
        isOpenIndustryModal: true,
        modalIndustryParentId: parentId,
        modalIndustryId: industryId
      };
    }
    case CLOSE_INDUSTRY_MODAL: {
      return { ...state, isOpenIndustryModal: false };
    }
    case CHANGE_INDUSTRY_MODAL: {
      const { name, value } = action;
      if (name === 'modalIndustryParentId') {
        return {
          ...state,
          modalIndustryParentId: value,
          modalIndustryId: null,
        };
      }
      return { ...state, [name]: value };
    }
    case OPEN_INDUSTRY_BY_ATTR_MODAL: {
      const { name, parentId, industryId, obj } = action;
      const { attrIndex, itemIndex } = obj;
      return {
        ...state,
        selectIndustry: name,
        isOpenIndustryByAttrModal: true,
        modalIndustryParentId: parentId,
        modalIndustryId: industryId,
        selectedAttrIndex: attrIndex,
        selectedAttrItemIndex: itemIndex
      };
    }
    case CLOSE_INDUSTRY_BY_ATTR_MODAL: {
      return { ...state, isOpenIndustryByAttrModal: false };
    }
    case DECIDE_INDUSTRY: {
      let industryInfo = {};
      switch (state.selectIndustry) {
        case "industry1":
          industryInfo = {
            industryParentId1: state.modalIndustryParentId,
            industryId1: state.modalIndustryId
          };
          break;
        case "industry2":
          industryInfo = {
            industryParentId2: state.modalIndustryParentId,
            industryId2: state.modalIndustryId
          };
          break;
        case "industry3":
          industryInfo = {
            industryParentId3: state.modalIndustryParentId,
            industryId3: state.modalIndustryId
          };
          break;
        default:
          industryInfo = {};
      }
      const reportStatus = state.reportStatus.merge(industryInfo);
      return {
        ...state,
        isOpenIndustryModal: false,
        reportStatus,
        modalIndustryParentId: state.modalIndustryParentId,
        modalIndustryId: state.modalIndustryId
      };
    }
    case DECIDE_INDUSTRY_BY_ATTR: {
      let industryInfo = {};
      switch (state.selectIndustry) {
        case "industry1":
          industryInfo = {
            parent: state.modalIndustryParentId,
            industry: state.modalIndustryId,
            index: 11
          };
          break;
        case "industry2":
          industryInfo = {
            parent: state.modalIndustryParentId,
            industry: state.modalIndustryId,
            index: 12
          };
          break;
        case "industry3":
          industryInfo = {
            parent: state.modalIndustryParentId,
            industry: state.modalIndustryId,
            index: 13
          };
          break;
        default:
          industryInfo = {};
      }

      const currentIndustry = industryInfo.industry || "NULL";
      const currentParent = industryInfo.parent || "NULL";
      state.surveyAttrs[state.selectedAttrIndex].items[state.selectedAttrItemIndex][industryInfo.index] = currentIndustry;
      state.surveyAttrs[state.selectedAttrIndex].items[state.selectedAttrItemIndex][industryInfo.index + 7] = currentParent;
      const industry = state.surveyAttrs[state.selectedAttrIndex].items[state.selectedAttrItemIndex][industryInfo.index];
      const parent = state.surveyAttrs[state.selectedAttrIndex].items[state.selectedAttrItemIndex][industryInfo.index + 7];   
      return {
        ...state,
        isOpenIndustryByAttrModal: false,
        industry: industry || "NULL",
        parent: parent || "NULL"
      };
    }
    case SET_ERRORS: {
      const { errors } = action;
      return { ...state, errors };
    }
    case SET_LOADING: {
      const { loading } = action;
      return { ...state, loading };
    }
    case SET_SURVEY_ATTR_SHOW_STATUS: {
      const { attrIndex, itemIndex, val } = action;
      const show = val === true ? 1 : 0;
      const newState = { ...state };
      newState.surveyAttrs[attrIndex].items[itemIndex][2] = show;
      return newState;
    }
    default:
      return state;
  }
};

export default report;



// WEBPACK FOOTER //
// ./src/redux/modules/report.js